import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PortalModal from '../../../components/PortalModal';
import { track, WEBREG_PREFIX } from '../../../utils/mixpanelHelper';
import {
  userManagementRootEndpoint,
  personifyHealth,
} from '../../../../config';
import { LOCAL_STORAGE_PH_AUTH_TIMESTAMP_KEY } from '../personify-health/usePersonifyHealth';
import { PAGES } from '../../../page-urls';
import Image from '../../../../media/session-expired.svg?react';
import { useI18n } from '../../../i18n/utils';
import { I18N_STR } from '../../../i18n/strings';

const FIFTEEN_MINUTES = 900000;
const TEN_SECONDS = 10000;

export default function PersonifyHealthSessionTimeoutModal() {
  const location = useLocation();
  const isEmailVerificationPage =
    location.pathname === PAGES.COMPLETE_REGISTRATION.url;
  const modalRef = useRef();
  const isPersonifyHealth = useSelector(state => state.isPersonifyHealth);
  const isRegistrationComplete = useSelector(
    state => state.registrationComplete
  );

  const [hasSessionTimedOut, setHasSessionTimedOut] = useState();
  const { str } = useI18n();

  const checkIfIsInAuthTimeFrame = () => {
    const authTimestamp =
      localStorage.getItem(LOCAL_STORAGE_PH_AUTH_TIMESTAMP_KEY) || 0;
    const timeSinceAuth = Date.now() - authTimestamp;
    setHasSessionTimedOut(timeSinceAuth >= FIFTEEN_MINUTES);
  };

  useEffect(() => {
    let interval;

    if (isPersonifyHealth) {
      interval = setInterval(checkIfIsInAuthTimeFrame, TEN_SECONDS);
      checkIfIsInAuthTimeFrame();
    }

    return () => interval && clearInterval(interval);
  }, []);

  useEffect(() => {
    if (hasSessionTimedOut && modalRef.current) {
      modalRef.current.focus();
    }
  }, [hasSessionTimedOut]);

  // skip rendering for anything not PH or not in AuthTimeFrame
  if (
    !isPersonifyHealth ||
    !hasSessionTimedOut ||
    isRegistrationComplete ||
    isEmailVerificationPage
  ) {
    return null;
  }

  return (
    <PortalModal onTop={true}>
      <div className="obstacle-modal ph-modal session-timeout-modal">
        <div className="inner-modal wrapper" ref={modalRef}>
          <Image />
          <h3>{str(I18N_STR.phTimeoutModalTitle)}</h3>
          <p>{str(I18N_STR.phTimeoutModalCopy)}</p>
          <div className="form-footer justify-left">
            <button
              className="cs-button"
              onClick={() => {
                track(`${WEBREG_PREFIX}:ph-modal-session-timeout`);
                window.location.replace(
                  `${userManagementRootEndpoint}/v1/login/saml?provider=${personifyHealth.authProvider}`
                );
              }}
            >
              {str(I18N_STR.phTimeoutModalButton)}
            </button>
          </div>
        </div>
      </div>
    </PortalModal>
  );
}
